import { render, staticRenderFns } from "./CounterpartyItem.vue?vue&type=template&id=0f90b173&"
import script from "./CounterpartyItem.vue?vue&type=script&lang=js&"
export * from "./CounterpartyItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports